import {classNames, React, useEffect, useLocalStore, observer} from '@api'
import {CatalogFieldRenderer} from '@lazy'
import {useCatalogItemSidebarDetailsStore} from '@modules'
import {SidebarTableRowStore} from '@modules/drawer/stores/SidebarTableRowStore'
import {ModalSectionRows} from '@stores'
import {useContext} from 'react'
import css from './AdoptionRegionView.css'

export const SidebarTableRowStoreContext = React.createContext<SidebarTableRowStore>(undefined)
export const useSidebarAdoptionStore = () => useContext(SidebarTableRowStoreContext)

export const TableRegionView = observer<{ rows: ModalSectionRows, hasFields: boolean, itemSource?: string }>(({rows, hasFields, itemSource}) => {
  const detailsStore = useCatalogItemSidebarDetailsStore(),
    store = useLocalStore(() => new SidebarTableRowStore(detailsStore, rows, itemSource))

  useEffect(() => store.registerEffects(), [])

  if (!store.adoptions || store.adoptions?.length === 0) return null
  return (
    <SidebarTableRowStoreContext.Provider value={store}>
      <div className={classNames(css.root, {[css.colSpan]: hasFields})}>
        <AdoptionHeader/>
        <AdoptionTotalHeader/>
        {store?.adoptions?.map(s => {
          return <AdoptionGridRow key={s.exId}>
            {rows?.columns?.map(column => {
              return <CatalogFieldRenderer key={`${column.field}_${s.exId}`} field={column} section={{id: s.exId, type: 'adoption'}}/>
            })}
          </AdoptionGridRow>
        })}
      </div>
    </SidebarTableRowStoreContext.Provider>
  )
})

export const AdoptionGridRow = observer<{ children: any, className?: any }>(({children, className}) => {
  const {rows: {style}} = useSidebarAdoptionStore()
  return (
    <div className={classNames(css.row, className)} style={{gridTemplateColumns: style?.gridColumns}}>{children}</div>
  )
})

export const AdoptionHeader = observer(() => {
  const store = useSidebarAdoptionStore()
  const {rows: {header}} = store
  return (
    <AdoptionGridRow>
      {header?.map(h => {
        if (_.isEmpty(h)) return <div key={`empty`}/>
        return <div className={css.header} key={`header_${h.label}`}>{h.label}</div>
      })}
    </AdoptionGridRow>
  )
})

export const AdoptionTotalHeader = observer(() => {
  const store = useSidebarAdoptionStore()
  const {rows: {total}, adoptions} = store

  return (
    <AdoptionGridRow className={css.total}>
      {total?.map(t => {
        if (!t.field) return <div key={`onlyLabel_${t.label}`} className={css.label}>{t.label}</div>
        // if (t.computed && t.def?.type !== 'Boolean') {
        //   return <div key={`expression_${t.field}`}>{t.computed.expression.compute(adoptions)}</div>
        // }
        if (t.agg) {
          switch (t.agg) {
            case 'sum': {
              const sum = adoptions.reduce((acc, val) => (acc + _.get(val, t.field)), 0)
              return <div key={`agg_${t.field}`}>{sum}</div>
            }
            case 'count': {
              const count = adoptions.reduce((acc, val) => (acc + (_.get(val, t.field) ? 1 : 0)), 0)
              return <div key={`count_${t.field}`}>{count}</div>
            }
          }
        }
        return <CatalogFieldRenderer field={t} key={`fieldRender_${t.field}`}/>
      })}
    </AdoptionGridRow>
  )
})


// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/SecondariesAdoptionRegion/TableRegionView.tsx